module.exports = __webpack_public_path__ + "img/学术会议-1.46627497.png";